export default "__VITE_ASSET__Cp9joj5o__"